import { isInvoice, isInvoiceList } from './isInvoice';

export function createInvoice(data?: IInvoiceDTO) {
  const invoice: IInvoiceDTO = {
    invoiceNumber: '',
    xmlURL: '',
    documentURL: '',
    orderNumber: '',
    billingDate: '',
    finalCustomerDocument: '',
    finalCustomerName: '',
    ...data,
  };

  return {
    ...invoice,
    isInvoice,
    isInvoiceList,
    getInvoiceDTO,
  };

  function getInvoiceDTO(): IInvoiceDTO {
    return { ...invoice };
  }
}
